<h1>Add a New Deal</h1>
<mat-horizontal-stepper [linear]="true" #stepper>
    <mat-step label="Define Deal Type" #step1 [completed]="false">
        <mat-card>
            <div class="card-header">
                <h2>Dealer Deal #</h2>
                <app-dealer-form [dealerFormProperties]="dealerFormProperties" (attachForm)="attachDealerForm($event)"> </app-dealer-form>
            </div>

            <div class="card-header">
                <h2>Define Your Deal Type</h2>
                <p *ngIf="groups.length > 0; else noTemplateGroups" class="instructions">Select one to define the documents associated with this deal</p>
                <ng-template #noTemplateGroups>
                    <p class="instructions">Select the deal type to define the associated documents</p>
                </ng-template>
                <div class="template-selection-container">
                    <button
                        mat-button
                        (click)="templateSelectionType = 'custom'"
                        [disabled]="groups.length <= 0"
                        [class.primary]="templateSelectionType === 'custom'"
                    >
                        Template Group
                    </button>
                    <button
                        mat-button
                        (click)="templateSelectionType = 'dealType'; templateGroupSelection = null"
                        [class.primary]="templateSelectionType === 'dealType'"
                    >
                        Deal Type
                    </button>
                </div>
                <hr />
            </div>

            <ng-container *ngIf="templateSelectionType === 'custom'"> </ng-container>

            <ng-container *ngIf="templateSelectionType === 'dealType'"> </ng-container>
        </mat-card>
        <div class="form-footer">
            <button
                id="deal-type-submit"
                class="primary"
                mat-button
                (click)="dealTypeFormSubmit()"
                [disabled]="!templateGroupSelection && templateSelectionType !== 'dealType'"
            >
                Next
            </button>
        </div>
    </mat-step>
    <mat-step label="Deal Information" #step2 [completed]="false">
        <mat-card>
            <div class="card-header">
                <h2>Add Buyer Information</h2>
                <p>* Indicates a required field</p>
                <ng-container *ngIf="buyerFound && !isBuyerDealer">
                    <p class="buyer-found">
                        Customer found! Is this the right person? If not, please verify and re-enter the email address. If it is the right person but some of
                        their information needs to be updated, the customer can do that through the profile screen when they log in.
                    </p>
                </ng-container>
                <p *ngIf="buyerFound && isBuyerDealer" class="customer-error">
                    The customer's email address is already being used by a Dealer. Please use a different email address.
                </p>
                <ng-container *ngIf="duplicateBuyer">
                    <p class="cobuyer-found">Buyer and Co-Buyer can't have the same email address.</p>
                </ng-container>
                <hr />
            </div>
            <app-customer-form-component
                [customerFormProperties]="customerFormProperties"
                [triggerFormErrors]="triggerCustomerFormErrors"
                (logonId)="customerLogon($event)"
                (attachForm)="attachBuyerForm($event)"
                (disableNext)="disableNext($event, 'buyer')"
                (isLoading)="isControlLoading($event)"
                (isUserFound)="isUserFound($event, 'buyer')"
                (goToEditView)="goToStep(createDealSteps.dealType)"
            >
            </app-customer-form-component>
            <div class="add-cobuyer-button">
                <button mat-button (click)="addCoBuyerToDeal()">
                    <span *ngIf="!addCoBuyer">Add Co-Buyer</span>
                    <span *ngIf="addCoBuyer">Remove Co-Buyer</span>
                </button>
            </div>
        </mat-card>

        <ng-container *ngIf="addCoBuyer">
            <mat-card>
                <div class="card-header">
                    <h2>Add Co-Buyer Information</h2>
                    <p>* Indicates a required field</p>
                    <hr />
                    <ng-container *ngIf="coBuyerFound && !isCobuyerDealer">
                        <p class="cobuyer-found">
                            Customer found! Is this the right person? If not, please verify and re-enter the email address. If it is the right person but some
                            of their information needs to be updated, the customer can do that through the profile screen when they log in.
                        </p>
                    </ng-container>
                    <p *ngIf="coBuyerFound && isCobuyerDealer" class="customer-error">
                        The customer's email address is already being used by a Dealer. Please use a different email address.
                    </p>
                    <ng-container *ngIf="duplicateBuyer">
                        <p class="cobuyer-found">Buyer and Co-Buyer can't have the same email address.</p>
                    </ng-container>
                </div>
                <app-customer-form-component
                    [customerFormProperties]="coBuyerFormProperties"
                    [triggerFormErrors]="triggerCoBuyerFormErrors"
                    (logonId)="coBuyerLogon($event)"
                    (attachForm)="attachCoBuyerForm($event)"
                    (disableNext)="disableNext($event, 'cobuyer')"
                    (isLoading)="isControlLoading($event)"
                    (isUserFound)="isUserFound($event, 'cobuyer')"
                    (goToEditView)="goToStep(createDealSteps.dealType)"
                >
                </app-customer-form-component>
            </mat-card>
        </ng-container>

        <mat-card class="trade-in-card">
            <div class="card-header">
                <h2>Trade-In Vehicle</h2>
                <div class="header-actions">
                    <button mat-button (click)="toggleTradeInVehicle()">
                        {{ hasTradeInVehicle ? 'Remove Trade-In' : 'Add Trade-In' }}
                    </button>
                </div>
            </div>
            <app-trade-in-form *ngIf="hasTradeInVehicle" [vehicle]="tradeInVehicle" (updated)="updateTradeInVehicle($event)"> </app-trade-in-form>
        </mat-card>

        <mat-card>
            <div class="card-header">
                <h2>Add Vehicle Information</h2>
                <hr />
            </div>
        </mat-card>
        <div class="form-footer">
            <button mat-button class="deal-info-back" (click)="goToStep(createDealSteps.dealType)">Back</button>
            <button
                mat-button
                class="deal-info-submit primary"
                (click)="dealDetailsFormSubmit()"
                [disabled]="!isReadyCustomer || !isReadyVehicle || (addCoBuyer && !isReadyCoBuyer) || isBuyerDealer || isCobuyerDealer"
            >
                Next
            </button>
        </div>
    </mat-step>

    <mat-step label="Review Deal" #step3 [completed]="false">
        <app-create-deal-summary-component
            *ngIf="stepper.selectedIndex === 2"
            [dealTypeSelections]="dealTypeSelections"
            [customerFormProperties]="customerFormProperties"
            [coBuyerFormProperties]="coBuyerFormProperties"
            [dealerFormProperties]="dealerFormProperties"
            [templateGroupSelection]="templateGroupSelection"
            [vehicleProperties]="selectedVehicle"
            [buyerFound]="buyerFound"
            [coBuyerFound]="coBuyerFound"
            [tradeInVehicle]="tradeInVehicle"
            (goToStep$)="goToStep($event)"
        ></app-create-deal-summary-component>
        <div class="form-footer">
            <button mat-button class="deal-info-back" (click)="goToStep(createDealSteps.details)">Back</button>
            <button mat-button class="deal-info-submit primary" (click)="createDealSubmit()" [disabled]="!isReadyCustomer || !isReadyVehicle">
                Start Your Deal
            </button>
        </div>
    </mat-step>
</mat-horizontal-stepper>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>
